export const RESET = 'SETTINGS/API_KEY_LIST_RESET';
export const REQUEST = 'SETTINGS/API_KEY_LIST_REQUEST';
export const RECEIVE = 'SETTINGS/API_KEY_LIST_RECEIVE';
export const REQUEST_ERROR = 'SETTINGS/API_KEY_LIST_REQUEST_ERROR';
